import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./states/auth/slice";
import productSlice from "./states/products/slice";
import categorySlice from "./states/Category/slice";
import bannersSlice from "./states/banners/slice";
import brandsSlice from "./states/brands/slice";
import testimonialsSlice from "./states/testimonial/slice";
import enquiriesSlice from "./states/enquiries/slice";
import blogsSlice from "./states/blogs/slice";
import ordersSlice from "./states/orders/slice";
import paymentsSlice from "./states/payments/slice";
import reviewsSlice from "./states/reviews/slice";
import trackingSlice from "./states/tracking/slice";
import clientsSlice from "./states/clients/slice";
import videocollectionsSlice from "./states/videoCollection/slice";
import contactUsSlice from "./states/conactus/slice";
import cartSlice from "./states/cartCollection/slice";

const rootReducer = combineReducers({
  auth: authReducer, //this reducer for auth
  products: productSlice, //this reducer for products
  categories: categorySlice, //this reducer for categories
  banners: bannersSlice, //this reducer for banners
  brands: brandsSlice, //this reducer for brands
  testimonials: testimonialsSlice, //this reducer for testimonials
  enquiries: enquiriesSlice, //this reducer for enquiries
  blogs: blogsSlice, //this reducer for blogs
  orders: ordersSlice, //this reducer for orders
  payments: paymentsSlice, //this reducer for payments
  reviews: reviewsSlice, //this reducer for reviews
  tracking: trackingSlice, //this reducer for tracking
  clients: clientsSlice, //this reducer for clients
  videocollection: videocollectionsSlice, //this reducer for clients
  contactUs: contactUsSlice, //this reducer for clients
  cart: cartSlice, //this reducer for clients
});

export default rootReducer;
